"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateResetPasswordForm = exports.checkIfResetPasswordDisabled = exports.RESEND_OTP_COUNTDOWN_DURATION = exports.resetPasswordInitialTouchedFieldsState = exports.resetPasswordInitialErrorState = void 0;
const utils_1 = require("../utils");
exports.resetPasswordInitialErrorState = {
    password: "",
    confirmPassword: "",
    otp: "",
};
exports.resetPasswordInitialTouchedFieldsState = {
    password: false,
    confirmPassword: false,
    otp: false,
};
exports.RESEND_OTP_COUNTDOWN_DURATION = 30;
const checkIfResetPasswordDisabled = (password, confirmPassword, otp) => {
    return !!((0, utils_1.validatePassword)(password) ||
        (0, utils_1.validateConfirmPassword)(password, confirmPassword) ||
        (0, utils_1.validateOtp)(otp));
};
exports.checkIfResetPasswordDisabled = checkIfResetPasswordDisabled;
const validateResetPasswordForm = (password, confirmPassword, otp, touchedFields) => {
    const fields = Object.keys(touchedFields);
    const errors = {
        password: "",
        confirmPassword: "",
        otp: "",
    };
    fields.forEach(field => {
        const touched = touchedFields[field];
        if (!touched)
            return;
        switch (field) {
            case "password":
                errors["password"] = (0, utils_1.validatePassword)(password);
                break;
            case "confirmPassword":
                errors["confirmPassword"] = (0, utils_1.validateConfirmPassword)(password, confirmPassword);
                break;
            case "otp":
                errors["otp"] = (0, utils_1.validateOtp)(otp);
                break;
        }
    });
    return errors;
};
exports.validateResetPasswordForm = validateResetPasswordForm;
